/**
 * 相当于 intval
 * @param str
 * @param fixed
 * @returns {number}
 */
export function runNum(str, fixed) {
  let _s = Number(str);
  if (_s + "" === "NaN") {
    _s = 0;
  }
  if (/^[0-9]*[1-9][0-9]*$/.test(fixed)) {
    _s = _s.toFixed(fixed);
    let rs = _s.indexOf(".");
    if (rs < 0) {
      _s += ".";
      for (let i = 0; i < fixed; i++) {
        _s += "0";
      }
    }
  }
  return _s;
}

/**
 * 克隆对象
 * @param myObj
 * @returns {*}
 */
export function cloneData(myObj) {
  if (typeof myObj !== "object") return myObj;
  if (myObj === null) return myObj;
  //
  if (typeof myObj.length === "number") {
    let [...myNewObj] = myObj;
    return myNewObj;
  } else {
    let { ...myNewObj } = myObj;
    return myNewObj;
  }
}

/**
 * 随机字符
 * @param len
 * @returns {string}
 */
export function randomString(len) {
  len = len || 32;
  let $chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678oOLl9gqVvUuI1";
  let maxPos = $chars.length;
  let pwd = "";
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}

/**
 * 判断是否为数组
 * @param {*} obj
 * @returns
 */
export function isArray(obj) {
  return (
    typeof obj == "object" &&
    Object.prototype.toString.call(obj).toLowerCase() == "[object array]" &&
    typeof obj.length == "number"
  );
}

/**
 * 将 JavaScript 值转换为 JSON 字符串（已try）
 * @param json
 * @param defaultVal
 * @returns {string}
 */
export function jsonStringify(json, defaultVal) {
  if (typeof json !== "object") {
    return json;
  }
  try {
    return JSON.stringify(json);
  } catch (e) {
    return defaultVal ? defaultVal : "";
  }
}
